// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"8fd836df","61":"ea1718b2","583":"d945a9c0","672":"60cc54a5","802":"0fc7ba31","916":"956611a5"}[chunkId] + ".chunk.css";
};